import React, { useState, useRef, useEffect } from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { graphql } from "gatsby";
import "../styles/info-viajes.css";
import { Link } from "gatsby";
import infoViajesBanner from "../images/info-viajes-banner.svg";
import ContactForm from "../components/ContactForm";
import CTAComponent from "../components/CTAComponent";
import Faq from "../components/Faq";

const Info = ({ data }) => {
  const {
    allStrapiInfoViajes: { nodes: qas },
  } = data;

  return (
    <>
      <GatsbySeo
        title="Informacion Viajera"
        description="Descubre todos nuestros destinos de viajes a buen precio"
        canonical="https://omega-agencia.netlify.app/info-viajes/"
        metaTags={[
          {
            property: "og:url",
            content: "https://omega-agencia.netlify.app/info-viajes/",
          },
          {
            property: "og:title",
            content: "Informacion Viajera | Omega Agencia de Viajes",
          },
        ]}
      />
      <div className="info-viajes-banner">
        <div className="info-viajes-title">
          <h1> Informacion Viajera</h1>
          <p>
            Toda la informacion que necesitas saber antes de viajar, para mas
            informacion contactanos!
          </p>
          <div className="viajes-btn">
            <Link to="/contactanos/">Contactanos</Link>
          </div>
        </div>
        <div>
          <img
            src={infoViajesBanner}
            className="info-viajes-img"
            alt="info viajes banner"
            loading="lazy"
          />
        </div>
      </div>
      <section>
        <div className="faq-section-title">
          <h2>Preguntas Frecuentes Viajeras</h2>
        </div>
        <Faq qas={qas} />
      </section>
      <CTAComponent />
      <ContactForm />
    </>
  );
};

export const query = graphql`
  {
    allStrapiInfoViajes {
      nodes {
        pregunta
        respuesta
      }
    }
  }
`;

export default Info;
